import type { HeadingProps } from "@chakra-ui/react";
import { Heading } from "@chakra-ui/react";
import React from "react";

export const H1 = (props: HeadingProps) => (
  <Heading
    as="h1"
    fontSize={{ base: "2xl", sm: "3xl", md: "4xl", lg: "5xl" }}
    {...props}
  />
);
